import { render, staticRenderFns } from "./SeatingInput.vue?vue&type=template&id=379a645e&scoped=true&lang=html"
import script from "./SeatingInput.vue?vue&type=script&lang=js"
export * from "./SeatingInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a645e",
  null
  
)

export default component.exports